import { render } from "./FoldersFlickr.vue?vue&type=template&id=3de6d8a4&scoped=true"
import script from "./FoldersFlickr.vue?vue&type=script&lang=js"
export * from "./FoldersFlickr.vue?vue&type=script&lang=js"

import "./FoldersFlickr.vue?vue&type=style&index=0&id=3de6d8a4&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de6d8a4"]])

export default __exports__